module.exports = __webpack_public_path__ + "img/comp_1.446dde83.jpg";